import React, { Component, PropTypes } from 'react';
import Translate from '../layout/Translate';
import Price from '../layout/Price';

export default class Cheque extends Component {
    render () {
        const { departure } = this.props.order;
        const order = this.props.order;
        const tour = this.props.tour;
        return (
            <div className="order__cheque cheque">
                <div className="cheque__title">
                    {tour.title}
                </div>
                <div className="cheque__departure">
                    {departure.formated_start_date} - {departure.formated_end_date}
                </div>
                <div className="cheque__line"></div>
                <div className="cheque__items">
                    <div className="cheque__item cheque__item_main"></div>
                    <div className="cheque__item">
                        <div className="cheque__name"><Translate slug="order__tour-price" />  x{order.count}</div>

                        {!!(departure.price * order.count) &&
                            <div className="cheque__price">
                                <Price price={departure.price} currency={departure.currency_id} />
                            </div>
                        }
                    </div>

                    {(order.options && order.options.length > 0) &&
                    <div>
                        {order.options.map((option, i) =>
                        <div>
                            {option.count>0 &&
                                <div className="cheque__item">
                                    <div className="cheque__name">{option.title} x{option.count}</div>
                                    <div className="cheque__price">
                                        <Price price={option.total} currency={departure.currency_id} />
                                    </div>
                                </div>
                            }
                        </div>
                        )}
                    </div>
                    }
                </div>

                {(!!order.total) &&
                    <div>
                        <div className="cheque__line"></div>
                        <div className="cheque__summary">
                            <Translate slug="order__summary" /> {order.count} <Translate slug="order__person-2-4" />
                            <div className="cheque__total">
                                <Price price={order.total} currency={departure.currency_id} />
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/common/components/order/Cheque.js